import { useNavigate } from "react-router-dom";

import { useApp } from "context/app";

import UserPicker from "components/UserPicker";

const Webmasters = ({ data, isDisabled, onChange }) => {
  const navigate = useNavigate();

  const { webmasters } = useApp();

  return (
    <UserPicker
      data={data.map((item) => ({ id: item?.uid || item?._id }))}
      options={webmasters.map((item) => ({
        id: item._id,
        name: `${item.first_name} ${item.last_name}`,
        image: item.photo?.location,
        onClick: () => navigate(`/webmasters/${item._id}`),
      }))}
      isDisabled={isDisabled}
      onChange={onChange}
    />
  );
};

export default Webmasters;
